
export default function Features() {
  const features = [
    {
      category: 'Security',
      title: 'Advanced Encryption & Protection',
      image: 'https://public.readdy.ai/ai/img_res/b881ea76b488b613b6d215c314fc85d8.jpg',
      description: 'Military-grade encryption protocols'
    },
    {
      category: 'Performance',
      title: 'Intelligent Device Optimization',
      image: 'https://readdy.ai/api/search-image?query=glowing%20neon%20cyan%20security%20shield%20icon%20with%20circuit%20board%20patterns%20and%20digital%20lock%20symbols%20on%20dark%20background%2C%20futuristic%20cybersecurity%20visualization%20with%20geometric%20shapes%20and%20data%20streams%2C%20high-tech%20protection%20concept%20art&width=600&height=800&seq=feature-shield&orientation=portrait',
      description: 'Smart algorithms for peak performance'
    },
    {
      category: 'User Experience',
      title: 'Seamless Interface Design',
      image: 'https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20showing%20cleaning%20process%20with%20animated%20progress%20circles%2C%20storage%20categories%20with%20colorful%20icons%2C%20before%20and%20after%20storage%20comparison%2C%20modern%20minimalist%20design%20with%20smooth%20gradients%20and%20clean%20typography&width=600&height=800&seq=feature-cleaning&orientation=portrait',
      description: 'Intuitive and easy to use'
    }
  ];

  return (
    <section id="features" className="py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div>
            <p className="text-3xl text-slate-500 italic font-serif mb-2">Designed to Enhance</p>
            <h2 className="text-5xl font-bold text-slate-900 leading-tight">
              User Experience & Security
            </h2>
          </div>
          
          <div className="flex items-center">
            <p className="text-lg text-slate-600 leading-relaxed">
              Our applications combine powerful functionality with elegant design, ensuring that protecting and optimizing your device is both effective and effortless.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="p-8">
                <div className="inline-block bg-cyan-100 text-cyan-600 text-xs font-medium px-4 py-2 rounded-full mb-4">
                  {feature.category}
                </div>
                
                <h3 className="text-3xl font-bold text-slate-900 leading-tight mb-3">
                  {feature.title}
                </h3>
                
                <p className="text-slate-600">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
